/**
 * Return the value only if it is a safe same-origin relative path: a single
 * leading slash, not a `//` or `/\` protocol-relative URL, and no control
 * characters (browsers strip tab/newline/CR, which can smuggle past the prefix
 * check, e.g. "/\t//evil"). Anything else falls back to '/' to prevent open
 * redirects after login.
 *
 * @param {string} value The candidate redirect target.
 *
 * @returns {string} A safe relative path, or '/'.
 */
export default (value) => {
  if (typeof value !== 'string') {
    return '/';
  }

  const hasControlChar = [...value].some((char) => {
    const code = char.charCodeAt(0);

    return code < 0x20 || code === 0x7f;
  });

  if (hasControlChar) {
    return '/';
  }

  return /^\/(?![/\\])/.test(value) ? value : '/';
};
